module.exports = __webpack_public_path__ + "28b67065/img/rename-icon.de4e673d.svg";